<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Listar Ordenes de Trabajo</h4>
            </div>
            <div class="card-body">
                <div class="form-body">
                    <!--
                        <h3 class="box-title">Listar Ordenes de Trabajo</h3>
                        <hr class="m-t-0 m-b-40">
                    -->
                    <!-- ======================== -->
                    <!-- ======= DATABASE ======= -->
                    <!-- ======================== -->
                    <div class="ordenes">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="tablaMaterial" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th>Id</th>
                                <th style="display:none">Cotizacion</th>
                                <th>Descripción</th>
                                <th>Tipo de cotización</th>
                                <th>Fecha</th>
                                <th>Sucursal</th>
                                <th>Estatus</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="text-align: center" *ngFor="let orden of arrayOrdenes">
                                <td>{{ orden.ordenTrabajoId }}</td>
                                <td style="display:none">{{ orden.id }}</td>
                                <td>{{ orden.descripcion }}</td>
                                <td>{{ orden.tipoCotizacion }}</td>
                                <td>{{ orden.fecha }}</td>
                                <td>{{ orden.sucursalNombre }}</td>
                                <td style="text-align: left"><span class="label" [style.background]="orden.estatus.color">{{ orden.estatus.nombre }}</span></td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                    <!-- ======================== -->
                    <!-- ======= DATABASE ======= -->
                    <!-- ======================== -->
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/listar-orden-trabajo/listar-orden-trabajo.component.html